const getters = {
  cartItems: (state) => state.cart || [],
};

export default getters;
